import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';

@model.cacheDuration()
@model.urnResource('invoice_status')
@doc.path('/invoice_statuses/{?id}')
export default class InvoiceStatusModel extends AccountServiceModel {
	@doc.string declare label: string;
	@doc.string declare reference: Account_InvoiceStatusReference;

	public get color() {
		switch (this.reference) {
			case 'PAID':
				return 'success';
			case 'PENDING_PAYMENT':
				return 'warning';
			case 'CANCELLED':
				return 'error';
			default:
				return 'default';
		}
	}
}